import { graphql } from "@opensea/graphql"
import { AcceptOffersSummaryFragment } from "../AcceptOffersSummary/AcceptOffersSummary.fragment"
import { getItemQuoteResultErrorFragment } from "./getItemQuoteResultError.fragment"
import { QuoteReceiptRowFragment } from "./QuoteReceiptRow.fragment"
import { QuoteReceiptTotalFragment } from "./QuoteReceiptTotal.fragment"

export const QuoteReceiptFragment = graphql(
  `
    fragment QuoteReceipt on Quote {
      itemQuotes {
        ... on WithQuoteItem {
          item {
            id
            tokenId
            contractAddress
          }
        }
        ...QuoteReceiptRow
        ...getItemQuoteResultError

        ... on ItemNotFound {
          item {
            tokenId
            chain {
              identifier
            }
            contractAddress
          }
        }
      }
      totalPrice {
        ...QuoteReceiptTotal
      }
      ...AcceptOffersSummary
    }
  `,
  [
    getItemQuoteResultErrorFragment,
    QuoteReceiptRowFragment,
    QuoteReceiptTotalFragment,
    AcceptOffersSummaryFragment,
  ],
)
